// src/pages/HomePage.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { IoSunny, IoMoon, IoStatsChart, IoHelpCircleOutline, IoPlay, IoLibrary } from 'react-icons/io5';
import StatsModal from '../components/StatsModal';
import HelpModal from '../components/HelpModal';
import ArchiveIntroModal from '../components/ArchiveIntroModal';
import CentumthPromo from '../components/CentumthPromo';
import { useStats } from '../hooks/useStats';

const DarkModeToggle = () => {
    const [isDarkMode, setIsDarkMode] = useState(() => localStorage.getItem('theme') === 'dark');

    useEffect(() => {
        if (isDarkMode) {
            document.documentElement.classList.add('dark');
            localStorage.setItem('theme', 'dark');
        } else {
            document.documentElement.classList.remove('dark');
            localStorage.setItem('theme', 'light');
        }
    }, [isDarkMode]);

    return (
        <button onClick={() => setIsDarkMode(!isDarkMode)} className="text-2xl">
            {isDarkMode ? <IoSunny /> : <IoMoon />}
        </button>
    );
};

const HomePage = () => {
  const [isStatsModalOpen, setIsStatsModalOpen] = useState(false);
  const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);
  const [isArchiveModalOpen, setIsArchiveModalOpen] = useState(false);
  const { stats } = useStats();
  const [dateString, setDateString] = useState('');

  useEffect(() => {
    const today = new Date();
    setDateString(today.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    }));
  }, []);

  // Updated button classes to match the rounded rectangle style of the Archive button
  const buttonClasses = "flex items-center justify-center space-x-2 text-sm font-semibold w-48 py-3 border border-transparent rounded-md shadow-sm text-white bg-black dark:bg-white hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 dark:text-gray-800 transition-colors";

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background dark:bg-dark-background text-foreground dark:text-dark-foreground">
      <div className="absolute top-4 right-4">
        <DarkModeToggle />
      </div>

      <img src="/wordamid-logo- final.png" alt="Wordamid Game Logo" className="w-80 h-auto" />
      <h1 className="text-5xl font-bold mb-4 tracking-wider">Wordamid</h1>
      <p className="text-lg mb-6 text-center max-w-md">Solve the daily word pyramid by guessing words of increasing length.</p>
      
      <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-4">
        <button 
          onClick={() => setIsStatsModalOpen(true)}
          className={buttonClasses}
        >
          <IoStatsChart className="text-xl" />
          <span>Statistics</span>
        </button>
        <button 
          onClick={() => setIsArchiveModalOpen(true)}
          className={buttonClasses}
        >
           <IoLibrary className="text-xl" />
          <span>Archive</span>
        </button>
        <button 
          onClick={() => setIsHelpModalOpen(true)}
          className={buttonClasses}
        >
           <IoHelpCircleOutline className="text-xl" />
          <span>How to Play</span>
        </button>
        <Link to="/game">
          <button className={buttonClasses}>
             <IoPlay className="text-xl" />
            <span>Play</span>
          </button>
        </Link>
      </div>

      <p className="mt-8 text-lg text-gray-500 dark:text-gray-400">{dateString}</p>

      <StatsModal 
        isOpen={isStatsModalOpen}
        onClose={() => setIsStatsModalOpen(false)}
        stats={stats}
      />
      <HelpModal 
        isOpen={isHelpModalOpen}
        onClose={() => setIsHelpModalOpen(false)}
      />
      <ArchiveIntroModal 
        isOpen={isArchiveModalOpen}
        onClose={() => setIsArchiveModalOpen(false)}
      />
      <CentumthPromo />
    </div>
  );
};

export default HomePage;
